




import NotifyMixin from '@/plugins/mixins/NotifyMixin'
import { parseAxiosValidationErrors } from '@ultraware/vee-form-handler'
import { AxiosError } from 'axios'
import ArticleForm from 'src/components/ArticleForm.vue'
import { createArticle, EDurationType, IArticle, readArticles } from 'src/store/article'

import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { IVxsPromise, vxsActionFetch, vxsActionSend } from 'vuex-xhr-state'

@Component({
  components: { ArticleForm },
})

export default class CreateArticleWrapper extends Mixins(NotifyMixin) {
  @Prop({ required: true, type: String }) private publisherName!: string
  @vxsActionSend(createArticle) private actionCreateArticle!: (_: IArticle) => IVxsPromise<void>
  @vxsActionFetch(readArticles) private fetchArticles!: () => IVxsPromise<IArticle[]>

  public article: IArticle = this.getNewArticle()
  public validationErrors: Record<string, string[]> = {}
  public customMapping: object = {
    PriceVATLow: 'price',
    PriceVATHigh: 'price',
  }

  @Watch('publisherName')
  public updatePublisherName(name: string): void {
    if (name === '') return
    this.article = this.getNewArticle()
  }

  public getNewArticle(): IArticle {
    return {
      ProductId: '',
      Authors: { Author: [this.publisherName] },
      Title: '',
      IsCatalogItem: true,
      Publisher: this.publisherName,
      PublisherThumbnailLocation: 'https://toegang.edu-ix.nl',
      IntendedEndUserRole: '',
      Medium: 'Web browser',
      IsConsumptionProduct: true,
      Sectors: { Sector: [] },
      Levels: { Level: [] },
      ProductState: null,
      Courses: { Course: [] },
      Currency: 'EUR',
      SaleUnitSize: 1,
      AccessLocation: 'https://toegang.edu-ix.nl/EAN',
      RedirectURL: '',
      PriceIsIndicative: false,
      IsLicensed: true,
      ContentLocation: '',
      ProductThumbnailLocation: '',
      DurationType: EDurationType.floating,
      DurationDays: 364,
      ServiceCreditAllowed: false,
      ZeroEnabled: false,
      ActivationCodeEnabled: false,
    }
  }

  public submit(article: IArticle): void {
    this.actionCreateArticle(article)
      .then(() => {
        this.showMessage('positive', 'Het artikel is succesvol aangemaakt')

        this.fetchArticles()

        // reset all fields
        this.article = this.getNewArticle()
      })
      .catch((axiosErr: AxiosError) => {
        const validationErrorsResult =
          parseAxiosValidationErrors(axiosErr, this.$vfh.dictionary)
        this.validationErrors = validationErrorsResult.errors
        if (!validationErrorsResult.resolved) throw axiosErr
      })
  }
}
